import type { Language } from '@yleisradio/areena-types';
import { useRouter } from 'next/router';

export function useUILanguage(): Language {
  const router = useRouter();
  return router && router.locale === 'sv' ? 'sv' : 'fi';
}
